export default "__VITE_ASSET__BXxBlVkJ__"